import { useFormContext } from "react-hook-form";
import { IConfigRegua } from "../../../../../../Interfaces/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaInterfaces";
import { IRegua } from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";

interface IGeralProps {
    configRegua?: IConfigRegua;
    lstRegua: Array<IRegua>;
}

interface IGeralFormData {
    ID_CASO_COBRANCA_REGUA: number;
    NR_HORA_INICIAL: string;
    NR_HORA_FINAL: string;
}

export default function Geral(props: IGeralProps) {
    const { register, formState } = useFormContext<IGeralFormData>();

    return (
        <div className="row">
            <div className="form-group col-12 col-lg-6">
                <label>Régua de Cobrança</label>
                <select
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.ID_CASO_COBRANCA_REGUA && "is-invalid"
                    }`}
                    defaultValue={props.configRegua?.ID_CASO_COBRANCA_REGUA}
                    name="ID_CASO_COBRANCA_REGUA"
                    ref={register({
                        required: "Insira a régua de cobrança",
                    })}
                >
                    <option></option>
                    {props.lstRegua.map((regua) => (
                        <option
                            value={regua.ID_CASO_COBRANCA_REGUA}
                            key={regua.ID_CASO_COBRANCA_REGUA}
                        >
                            {regua.DS_NOME_REGUA}
                        </option>
                    ))}
                </select>
                <div className="invalid-feedback">
                    {formState.errors.ID_CASO_COBRANCA_REGUA
                        ? formState.errors.ID_CASO_COBRANCA_REGUA.message
                        : ""}
                </div>
            </div>
            <div className="col-12 col-lg-6 p-0">
                <div className="form-group col-12">
                    <label>Horário de Início</label>
                    <input
                        className={`form-control placeholder-dark-75 ${
                            formState.errors.NR_HORA_INICIAL && "is-invalid"
                        }`}
                        type="time"
                        defaultValue={props.configRegua?.NR_HORA_INICIAL}
                        name="NR_HORA_INICIAL"
                        ref={register({
                            required: "Insira o horário de início",
                        })}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.NR_HORA_INICIAL
                            ? formState.errors.NR_HORA_INICIAL.message
                            : ""}
                    </div>
                </div>
                <div className="form-group col-12">
                    <label>Horário de Encerramento</label>
                    <input
                        className={`form-control placeholder-dark-75 ${
                            formState.errors.NR_HORA_FINAL && "is-invalid"
                        }`}
                        type="time"
                        defaultValue={props.configRegua?.NR_HORA_FINAL}
                        name="NR_HORA_FINAL"
                        ref={register({
                            required: "Insira o horário de encerramento",
                        })}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.NR_HORA_FINAL
                            ? formState.errors.NR_HORA_FINAL.message
                            : ""}
                    </div>
                </div>
            </div>
        </div>
    );
}
